import React from "react";

export default function REST() {
    return (
        <div>
            REST
        </div>
    )
}
